import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { Checkbox } from "@progress/kendo-react-inputs";

export const AdministratorMyShortedEventsWithLowMargin = () => {
    const dispatch = useDispatch();

    const [myShortedEventsWithLowMargin, setMyShortedEventsWithLowMargin] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [totalEventCount, setTotalEventCount] = useState(0);
    const [onlyShowBroadcastedEventsFilterValue, setOnlyShowBroadcastedEventsFilterValue] = useState(false);

    const initialPageState = {
        skip: 0,
        take: 20,
    };
    const [page, setPage] = useState(initialPageState);
    const pageChange = (event) => {
        setPage(event.page);
    };

    const getMyShortedEventsWithLowMargin = (onlyShowBroadcastedEvents) => {
        setIsLoading(true);

        if (onlyShowBroadcastedEvents === undefined) {
            onlyShowBroadcastedEvents = onlyShowBroadcastedEventsFilterValue;
        }

        const dataItem = {
            onlyShowBroadcastedEvents: onlyShowBroadcastedEvents,
        };

        fetch(`/api/administrator/pos/myshortedeventswithlowmargin`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setMyShortedEventsWithLowMargin(result);
                setTotalEventCount(result.length);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const getGridData = () => {
        return myShortedEventsWithLowMargin.slice(page.skip, page.take + page.skip);
    };

    const ViewUrlCell = (props) => {
        const url = props.dataItem[props.field];

        return (
            <td className={"text-nowrap"}>
                {url ? <Link to={{ pathname: url }} target={"_blank"} rel={"noopener noreferrer"}>View Website</Link> : ""}
            </td>
        );
    };

    const onlyShowBroadcastedEventsFilterValueChanged = (event) => {
        const value = event.value;

        setOnlyShowBroadcastedEventsFilterValue(value);
        getMyShortedEventsWithLowMargin(value);
    }

    useEffect(() => {
        document.title = "My Shorted Low Margin Events";

        getMyShortedEventsWithLowMargin();
    }, []);

    return (
        <div className="administratorReport">
            {isLoading ? <LoadingPanel /> : <></>}

            <div className="k-form k-form-md">
                <div className="k-form-fieldset container">
                    <div className="row">
                        <div className="col-12">
                            <div className="k-form-field">
                                <Checkbox
                                    label={"Only show broadcasted events"}
                                    onChange={onlyShowBroadcastedEventsFilterValueChanged}
                                    value={onlyShowBroadcastedEventsFilterValue}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Grid
                data={getGridData()}
                resizable={true}
                skip={page.skip}
                take={page.take}
                total={totalEventCount}
                pageable={true}
                onPageChange={pageChange}
                scrollable="none"
            >
                <Column field="ticketingUrl" title={"Website"} cell={ViewUrlCell} />
                <Column field="cost" title={"Cost"} />
                <Column field="price" title={"Price"} />
                <Column field="priceDifference" title={"Difference"} />
                <Column field="ticketingWebsiteName" title={"Website"} />
                <Column field="eventName" title={"Event"} />
                <Column field="venueName" title={"Venue"} />
                <Column field="eventDateAsString" title={"Date"} />
                <Column field="venueEventStatusTypeName" title={"Status"} />
                <Column field="isBroadcasted" title={"Broadcasted"} />
            </Grid>
        </div>
    );
}